export default __webpack_public_path__ + "static/media/footerlogo.f9e99306.svg";